// Small color helpers for contrast-safe accents. No DOM, so tests can import it.

export function parseHex(v) {
	let h = String(v || "").trim().replace(/^#/, "");
	if (h.length === 3) h = h.replace(/./g, "$&$&");
	if (!/^[0-9a-f]{6}$/i.test(h)) return null;
	const n = parseInt(h, 16);
	return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function toHex([r, g, b]) {
	return "#" + [r, g, b].map((x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, "0")).join("");
}

export function luminance(rgb) {
	const [r, g, b] = rgb.map((v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; });
	return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrast(a, b) {
	const x = luminance(Array.isArray(a) ? a : parseHex(a)), y = luminance(Array.isArray(b) ? b : parseHex(b));
	return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
}

const mix = (a, b, t) => a.map((v, i) => v + (b[i] - v) * t);

// color-mix(in srgb, a p%, b) for two hex colors
export function mixHex(a, b, p) {
	const x = parseHex(a), y = parseHex(b);
	if (!x || !y) return a;
	return toHex(mix(y, x, p).map(Math.round));
}

// The accent as text: unchanged when it already reads at `min` on every background,
// otherwise nudged toward black (light pages) or white (dark pages) until it does.
// Keeps the hue, so links still look like the accent.
export function inkFor(accent, bgs, min = 4.5) {
	const a = parseHex(accent);
	const list = bgs.map(parseHex).filter(Boolean);
	if (!a || !list.length) return accent;
	const ok = (c) => list.every((bg) => contrast(c, bg) >= min);
	if (ok(a)) return toHex(a);
	const light = luminance(list[0]) > 0.35;
	const target = light ? [0, 0, 0] : [255, 255, 255];
	for (let t = 0.04; t <= 1; t += 0.04) {
		const c = mix(a, target, t).map(Math.round);
		if (ok(c)) return toHex(c);
	}
	return toHex(target);
}

// Text that sits on an accent fill: the house dark ink when it reads, else white.
export function onAccent(accent, dark = "#1a1500") {
	const a = parseHex(accent);
	if (!a) return dark;
	const d = contrast(dark, a), w = contrast("#ffffff", a);
	return d >= 4.5 || d >= w ? dark : "#ffffff";
}
